import { App } from "antd";
import dayjs from "dayjs";
import { useCallback } from "react";
import { postSchedulerAddUnscheduledPointVisits } from "tm-shared/api";
import { backendDateFormat } from "tm-shared/constants";
import { countText } from "tm-shared/utils";

import { ROLE_CHILDREN_MAP } from "@/constants";
import {
    useAppDispatch,
    useAppSelector,
    useProtectedUserRoleSelector,
} from "@/hooks";
import { setUpdateUnscheduledPointsProcessing } from "@/store/slices/offline";
import { isManagerRole } from "@/utils/business/isManagerRole";

interface AddUnscheduledVisitsParams {
    pointIds: string[];
}

export const useAddUnscheduledVisits = () => {
    const { notification } = App.useApp();

    const role = useProtectedUserRoleSelector();
    const userId = useAppSelector((s) => s.user.id);
    const { activeSchedule } = useAppSelector((s) => s.manager);

    const dispatch = useAppDispatch();

    const addUnscheduledVisits = useCallback(
        async ({ pointIds }: AddUnscheduledVisitsParams) => {
            const isManager = isManagerRole(role);

            const roleSlug = isManager ? ROLE_CHILDREN_MAP[role] : role;
            const agentId = isManager ? activeSchedule?.userId : userId;

            if (!roleSlug || !agentId) {
                notification.error({
                    title: "Недостатньо даних",
                    description: `роль: ${roleSlug}, id користувача: ${agentId}`,
                });

                return;
            }

            await postSchedulerAddUnscheduledPointVisits(
                {
                    agentId,
                    role: roleSlug,
                    pointIds,
                    date: dayjs().format(backendDateFormat.date),
                },
                { config: { isAsync: { userId } } },
            );

            dispatch(setUpdateUnscheduledPointsProcessing(true));

            notification.success({
                title: `Запит на додавання ${countText.unplanned(
                    pointIds.length,
                )} ТТ успішно надіслано. Ми повідомимо вас про результат.`,
            });
        },
        [notification, activeSchedule?.userId, dispatch, role, userId],
    );

    return { addUnscheduledVisits };
};
